import { FooterContainer, FooterContent } from "./style";

export function Footer() {
  return (
    <FooterContainer>
      <FooterContent>
        <ul>
          <li>Trabalhe Conosco</li>
          <li>Termos e Condições</li>
          <li>Política de trocas</li>
          <li>Contato</li>
        </ul>
        <p>
          Copyright © 2023 Happy Shop <br /> CNPJ n.º 00.000.000/0000-00 / Av.
          Exemplo Avenida, nº 1500, Centro, São Paulo/SP - CEP 00000-000.
        </p>
      </FooterContent>
    </FooterContainer>
  );
}
